import { render, staticRenderFns } from "./FiltersPopup.vue?vue&type=template&id=55243d41"
import script from "./FiltersPopup.vue?vue&type=script&lang=ts"
export * from "./FiltersPopup.vue?vue&type=script&lang=ts"
import style0 from "./FiltersPopup.vue?vue&type=style&index=0&id=55243d41&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports